export const AUTH_DISPLAY = "'Tilda Sans', sans-serif"
export const AUTH_BODY = "'Manrope', sans-serif"
export const AUTH_MONO = "'JetBrains Mono', monospace"

export const authShellClass =
    "flex min-h-[calc(100vh-52px)] flex-col items-center justify-center gap-9 px-5 py-8 text-white md:min-h-auto"

/** Длинные формы (регистрация): компактная колонка сверху вниз */
export const authFormShellClass =
    "flex w-full shrink-0 flex-col items-stretch gap-4 px-5 pb-8 pt-2 text-white md:items-center md:gap-6 md:py-8"

export const authTitleClass = "text-center text-[28px] leading-tight tracking-tight sm:text-[32px]"

export const authTitleStyle = {
    fontFamily: AUTH_DISPLAY,
    fontWeight: 800,
    letterSpacing: "-0.02em",
} as const

export const authSubtitleClass = "text-center text-[20px] leading-snug sm:text-[22px]"

export const authSubtitleStyle = {
    fontFamily: AUTH_DISPLAY,
    fontWeight: 700,
    letterSpacing: "-0.01em",
} as const

export const authCaptionClass = "text-center text-[13px] leading-relaxed text-white/60"

export const authCaptionStyle = {
    fontFamily: AUTH_BODY,
    fontWeight: 500,
} as const

export const authPhoneClass = "text-center text-[28px] leading-tight tracking-tight sm:text-[32px]"

export const authPhoneStyle = {
    fontFamily: AUTH_DISPLAY,
    fontWeight: 800,
    letterSpacing: "-0.02em",
    color: "#349be6",
} as const

export const authPhoneInlineClass = "text-[#349be6]"

export const authPhoneInlineStyle = {
    fontFamily: AUTH_DISPLAY,
    fontWeight: 700,
    letterSpacing: "-0.01em",
} as const

export const authLinkClass = "text-white underline underline-offset-2 transition-colors hover:text-white/85"

export const authBtnClass =
    "flex h-[50px] w-[328px] max-w-full cursor-pointer items-center justify-center rounded-full px-6 text-[14px] font-bold text-white transition-all hover:opacity-95 disabled:cursor-not-allowed disabled:opacity-50"

export const authBtnPrimaryStyle = {
    fontFamily: AUTH_MONO,
    fontWeight: 700,
    letterSpacing: "0.04em",
    background: "#e4206b",
    boxShadow: "0 0 22px rgba(228, 32, 107, 0.4)",
} as const

export const authBtnSecondaryStyle = {
    fontFamily: AUTH_MONO,
    fontWeight: 700,
    letterSpacing: "0.04em",
    background: "#349be6",
    boxShadow: "0 0 22px rgba(52, 155, 230, 0.35)",
} as const

export const authCheckboxClass =
    "mt-0.5 h-5 w-5 shrink-0 cursor-pointer appearance-none rounded-md border-2 border-white/25 bg-white/5 transition-all checked:border-[#349be6] checked:bg-[#349be6] hover:border-white/40"

export const authLabelClass = "min-w-0 flex-1 text-left text-[13px] leading-snug text-white/85"

export const authLabelStyle = {
    fontFamily: AUTH_BODY,
    fontWeight: 500,
} as const
